import { z } from 'zod';

export const SPRINT_STATUSES = ['planning', 'active', 'completed'] as const;
export const sprintStatusEnum = z.enum(SPRINT_STATUSES);
export type SprintStatus = z.infer<typeof sprintStatusEnum>;

export const createSprintSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(120),
  goal: z.string().trim().max(1000).optional().or(z.literal('')),
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
});

export type CreateSprintInput = z.infer<typeof createSprintSchema>;

export const updateSprintSchema = createSprintSchema.partial();
export type UpdateSprintInput = z.infer<typeof updateSprintSchema>;

/** When a sprint is completed with items still not `done`, they move to this sprint, or the backlog if omitted. */
export const completeSprintSchema = z.object({
  moveIncompleteToSprintId: z.string().optional(),
});

export type CompleteSprintInput = z.infer<typeof completeSprintSchema>;
